import { useEffect, useLayoutEffect } from 'react'

import { getChatRoomById } from 'api/chats'
import { TChannelDepartment } from 'App/components/UnityHub/UnityHubCreateChannels'
import { useQuery } from 'services/query'

export type TUseChatDepartmentsRequestProps = {
  channelId: string
  setChannelDepartments: (acc: TChannelDepartment[], prefetched?: boolean) => void

  isEdit?: boolean
}

export const useChatDepartmentsRequest = ({
  isEdit,
  channelId,
  setChannelDepartments
}: TUseChatDepartmentsRequestProps) => {
  const {
    data: departments = [],
    refetch,
    isInitialLoading: isLoading
  } = useQuery({
    queryKey: ['get-channel-departments', channelId],
    queryFn: () => getChatRoomById(channelId),
    select: (data) => data?.departments,
    enabled: false,
    cacheTime: 0
  })

  useLayoutEffect(() => {
    if (isEdit) {
      refetch()
    }
  }, [isEdit, refetch])

  useEffect(() => {
    if (isEdit && departments?.length) {
      setChannelDepartments(departments, true)
    }
  }, [isEdit, departments, setChannelDepartments])

  return { isLoading }
}
